import {MARK_INTERCOM_TESTER_REQUESTED, SET_INTERCOM_SETTINGS, STOP_INTERCOM_CHAT} from './actionTypes'
import initialState from '../intercom/initialState'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_INTERCOM_SETTINGS:
      return {
        ...state,
        ...action.settings
      }
    case STOP_INTERCOM_CHAT:
      return {
        ...initialState
      }
    case MARK_INTERCOM_TESTER_REQUESTED:
      return {
        ...state,
        requestForTestersHasSent: true
      }
    default:
      return state
  }
}
